module.exports = __webpack_public_path__ + "static/img/sec2-content@w.9cf9625.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/design-samsung/sec2-content@w.png
// module id = R3w/
// module chunks = 0